<template>
  <section>
    <qx-search-box
      class="searchBox"
      ref="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        oilCardTypeOptions: [],
        oilCardStatusOptions: [],
        cardTypeOptions: [],
        form: [
          {
            label: '油卡类型',
            value: 'oilCardType',
            type: 'select',
            default: -1,
            placeholder: '请选择油卡类型',
          },
          {
            label: '子卡卡号',
            value: 'oilCarNum',
            type: 'input',
            placeholder: '请输入子卡卡号',
          },
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          // { // 子卡状态
          //   label: '子卡状态',
          //   value: 'oilCardStatus',
          //   type: 'select',
          //   default: -1,
          //   placeholder: '请输入子卡状态',
          // },
          { // 服务商
            label: '服务商',
            value: 'companyName',
            type: 'input',
            placeholder: '请输入服务商',
          },
          { // 来源类型
            label: '来源类型',
            value: 'cardType',
            type: 'select',
            default: '',
            placeholder: '请选择来源类型',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      this.$refs.tableBox.saveSearchBoxData({
        cardCategory: this.$route.path.includes('oil') ? 1 : 2,
        ...searchBoxData,
      });
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'SERV_OIL_CARD_TYPE,OILCARD_STATUS,OIL_CARD_TYPE,GAS_CARD_TYPE,SERV_GAS_CARD_TYPE',
    });
    this.searchBoxData.oilCardTypeOptions = this.$route.path.includes('gasCard') ? [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[4],
    ] : [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[0],
    ];
    this.searchBoxData.oilCardStatusOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[1],
    ];
    this.searchBoxData.cardTypeOptions = this.$route.path.includes('gasCard') ? [ // 来源类型
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[3],
    ] : [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[2],
    ];
    if (this.$route.path.includes('gasCard')) {
      this.searchBoxData.form.forEach((item) => {
        if (item.label.includes('油卡')) {
          item.label = item.label.replace(/油卡/g, '气卡');
        }
        if (item.placeholder && item.placeholder.includes('油卡')) {
          item.placeholder = item.placeholder.replace(/油卡/g, '气卡');
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
